import React, { useEffect, useState } from "react";
import { Breadcrumb, PageHeader, Table, Spin, message, Button, Tag } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import MudFormsSearch from "./MudFormsSearch";
import { reportService, documentService } from "_services";
import moment from "moment";

function MudForms() {
  const [mudForms, setMudForms] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileDownloading, setFileDownloading] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMudForms();
  }, []);

  const onClear = () => {};

  const fetchMudForms = () => {
    setLoading(true);

    reportService
      .getMudForms()
      .then((data) => {
        setMudForms(data.content ?? []);
        setLoading(false);
      })
      .catch((error) => {
        message.error(error ?? "Error!");
        setLoading(false);
      });
  };
  const handleSearchResults = (values) => {
    setMudForms(values);
    setLoading(false);
  };
  const handleDownloadFile = (documentObj) => {
    setFileDownloading((prev) => ({ ...prev, [documentObj.id]: true }));
    documentService
      .downloadDocument(documentObj.id)
      .then((response) => {
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${documentObj.documentName}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setFileDownloading((prev) => ({ ...prev, [documentObj.id]: false }));
      })
      .catch((error) => {
        setError(error);
        setFileDownloading((prev) => ({ ...prev, [documentObj.id]: false }));
      });
  };

  const getMudFormColumns = () => {
    let columns = [];

    columns.push({
      title: "Cus Dec No#",
      dataIndex: "customReferenceNumber",
      key: "customReferenceNumber",
      align: "left",
      render: (text) => <Tag color="#13c2c2">{text}</Tag>,
    });

    columns.push({
      title: "Issue No#",
      dataIndex: "issueNumber",
      key: "issueNumber",
      align: "left",
    });

    columns.push({
      title: "Issue Date",
      dataIndex: "issuedDate",
      key: "issuedDate",
      align: "left",
      render: (text, record) => moment(text ?? 0).format("YYYY-MMM-DD"),
    });

    columns.push({
      title: "MUD Form No#",
      dataIndex: "mudReferenceNumber",
      key: "mudReferenceNumber",
      align: "left",
      render: (text, record) => text ?? "-",
    });
    columns.push({
      title: "Status",
      dataIndex: "orderStage",
      key: "orderStage",
      align: "left",
      render: (text, record) => text ?? "-",
      render: (text, record) => <Tag color={text === "ISSUED" ? "blue" : text === "DELIVERED" ? "green" : "purple"}>{text}</Tag>,
    });

    columns.push({
      title: "MUD Form",
      dataIndex: "documentName",
      key: "documentName",
      align: "center",
      render: (text, record) => (
        <Button
          title={text}
          type="link"
          loading={fileDownloading[record.id]}
          style={{ marginRight: 10 }}
          onClick={() => handleDownloadFile(record)}
        >
          {text} <DownloadOutlined />
        </Button>
      ),
    });

    return columns;
  };
  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/reports">Reports</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/reports/Aging-Reports">MUD Forms</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
    >
      <Page inner error={error}>
        <Spin spinning={loading}>
          <MudFormsSearch
            onClear={onClear}
            showSearchLoading={setLoading}
            onSearchResults={handleSearchResults}
          />

          {mudForms && (
            <Table
              bordered
              rowKey="id"
              pagination={false}
              columns={getMudFormColumns()}
              dataSource={mudForms}
              size="small"
            ></Table>
          )}
        </Spin>
      </Page>
    </PageHeader>
  );
}

export default MudForms;
